/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../src/app/app.module';
import * as i2 from '../../../src/app/containers/app/app.component';
import * as i3 from './containers/app/app.component.ngfactory';
import * as i4 from '@angular/common';
import * as i5 from '@angular/platform-browser';
import * as i6 from 'angularfire2/app/firebase.app.module';
import * as i7 from 'angularfire2/app/index';
import * as i8 from 'angularfire2/angularfire2';
import * as i9 from 'angularfire2/auth/auth';
import * as i10 from 'angularfire2/auth/auth.module';
import * as i11 from 'angularfire2/database/database';
import * as i12 from 'angularfire2/database/database.module';
import * as i13 from '@angular/forms';
import * as i14 from '../../../src/store';
import * as i15 from '../../../src/auth/shared/services/auth/auth.service';
import * as i16 from '../../../src/auth/shared/guards/auth.guard';
import * as i17 from '@angular/router';
import * as i18 from '../../../src/health/shared/services/meals/meals.service';
import * as i19 from '../../../src/health/shared/services/workouts/workouts.service';
import * as i20 from '../../../src/health/shared/services/schedule/schedule.service';
import * as i21 from '../../../src/auth/shared/shared.module';
import * as i22 from '../../../src/auth/auth.module';
import * as i23 from '../../../src/health/shared/shared.module';
import * as i24 from '../../../src/health/health.module';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.AppComponentNgFactory]],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),
          i0.ɵmpd(5120,i0.LOCALE_ID,i0.ɵm,[[3,i0.LOCALE_ID]]),i0.ɵmpd(4608,i4.NgLocalization,
              i4.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,
              ([] as any[])),i0.ɵmpd(5120,i0.IterableDiffers,i0.ɵk,([] as any[])),
          i0.ɵmpd(5120,i0.KeyValueDiffers,i0.ɵl,([] as any[])),i0.ɵmpd(4608,i5.DomSanitizer,
              i5.ɵe,[i4.DOCUMENT]),i0.ɵmpd(6144,i0.Sanitizer,(null as any),[i5.DomSanitizer]),
          i0.ɵmpd(4608,i5.HAMMER_GESTURE_CONFIG,i5.HammerGestureConfig,([] as any[])),
          i0.ɵmpd(5120,i5.EVENT_MANAGER_PLUGINS,(p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
            return [new i5.ɵDomEventsPlugin(p0_0),new i5.ɵKeyEventsPlugin(p1_0),new i5.ɵHammerGesturesPlugin(p2_0,
                p2_1)];
          },[i4.DOCUMENT,i4.DOCUMENT,i4.DOCUMENT,i5.HAMMER_GESTURE_CONFIG]),i0.ɵmpd(4608,
              i5.EventManager,i5.EventManager,[i5.EVENT_MANAGER_PLUGINS,i0.NgZone]),
          i0.ɵmpd(135680,i5.ɵDomSharedStylesHost,i5.ɵDomSharedStylesHost,[i4.DOCUMENT]),
          i0.ɵmpd(4608,i5.ɵDomRendererFactory2,i5.ɵDomRendererFactory2,[i5.EventManager,
              i5.ɵDomSharedStylesHost]),i0.ɵmpd(6144,i0.RendererFactory2,(null as any),
              [i5.ɵDomRendererFactory2]),i0.ɵmpd(6144,i5.ɵSharedStylesHost,(null as any),
              [i5.ɵDomSharedStylesHost]),i0.ɵmpd(4608,i0.Testability,i0.Testability,
              [i0.NgZone]),i0.ɵmpd(4608,i5.Meta,i5.Meta,[i4.DOCUMENT]),i0.ɵmpd(4608,
              i5.Title,i5.Title,[i4.DOCUMENT]),i0.ɵmpd(5120,i6.FirebaseApp,i7._firebaseAppFactory,
              [i6.FirebaseAppConfigToken,i8.FirebaseAppName]),i0.ɵmpd(5120,i9.AngularFireAuth,
              i10._getAngularFireAuth,[i6.FirebaseApp]),i0.ɵmpd(5120,i11.AngularFireDatabase,
              i12._getAngularFireDatabase,[i6.FirebaseApp]),i0.ɵmpd(4608,i13.FormBuilder,
              i13.FormBuilder,([] as any[])),i0.ɵmpd(4608,i13.ɵi,i13.ɵi,([] as any[])),
          i0.ɵmpd(4608,i14.Store,i14.Store,([] as any[])),i0.ɵmpd(4608,i15.AuthService,
              i15.AuthService,[i14.Store,i9.AngularFireAuth]),i0.ɵmpd(4608,i16.AuthGuard,
              i16.AuthGuard,[i17.Router,i15.AuthService]),i0.ɵmpd(4608,i18.MealsService,
              i18.MealsService,[i14.Store,i11.AngularFireDatabase,i15.AuthService]),
          i0.ɵmpd(4608,i19.WorkoutsService,i19.WorkoutsService,[i14.Store,i11.AngularFireDatabase,
              i15.AuthService]),i0.ɵmpd(4608,i20.ScheduleService,i20.ScheduleService,
              [i14.Store,i15.AuthService,i11.AngularFireDatabase]),i0.ɵmpd(5120,i17.ActivatedRoute,
              i17.ɵf,[i17.Router]),i0.ɵmpd(4608,i17.NoPreloading,i17.NoPreloading,
              ([] as any[])),i0.ɵmpd(6144,i17.PreloadingStrategy,(null as any),[i17.NoPreloading]),
          i0.ɵmpd(135680,i17.RouterPreloader,i17.RouterPreloader,[i17.Router,i0.NgModuleFactoryLoader,
              i0.Compiler,i0.Injector,i17.PreloadingStrategy]),i0.ɵmpd(4608,i17.PreloadAllModules,
              i17.PreloadAllModules,([] as any[])),i0.ɵmpd(5120,i17.ROUTER_INITIALIZER,
              i17.ɵi,[i17.ɵg]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,(p0_0:any) => {
            return [p0_0];
          },[i17.ROUTER_INITIALIZER]),i0.ɵmpd(512,i4.CommonModule,i4.CommonModule,
              ([] as any[])),i0.ɵmpd(1024,i0.ErrorHandler,i5.ɵa,([] as any[])),i0.ɵmpd(1024,
              i0.NgProbeToken,() => {
                return [i17.ɵb()];
              },([] as any[])),i0.ɵmpd(512,i17.ɵg,i17.ɵg,[i0.Injector]),i0.ɵmpd(1024,
              i0.APP_INITIALIZER,(p0_0:any,p0_1:any,p1_0:any) => {
                return [i5.ɵc(p0_0,p0_1),i17.ɵh(p1_0)];
              },[[2,i5.NgProbeToken],[2,i0.NgProbeToken],i17.ɵg]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i5.BrowserModule,i5.BrowserModule,[[3,i5.BrowserModule]]),i0.ɵmpd(1024,
              i17.ɵa,i17.ɵd,[[3,i17.Router]]),i0.ɵmpd(512,i17.UrlSerializer,i17.DefaultUrlSerializer,
              ([] as any[])),i0.ɵmpd(512,i17.ChildrenOutletContexts,i17.ChildrenOutletContexts,
              ([] as any[])),i0.ɵmpd(256,i17.ROUTER_CONFIGURATION,{},([] as any[])),
          i0.ɵmpd(1024,i4.LocationStrategy,i17.ɵc,[i4.PlatformLocation,[2,i4.APP_BASE_HREF],
              i17.ROUTER_CONFIGURATION]),i0.ɵmpd(512,i4.Location,i4.Location,[i4.LocationStrategy]),
          i0.ɵmpd(512,i0.Compiler,i0.Compiler,([] as any[])),i0.ɵmpd(512,i0.NgModuleFactoryLoader,
              i0.SystemJsNgModuleLoader,[i0.Compiler,[2,i0.SystemJsNgModuleLoaderConfig]]),
          i0.ɵmpd(1024,i17.ROUTES,() => {
            return [[{path:'auth',children:[{path:'',pathMatch:'full',redirectTo:'login'},
                {path:'login',loadChildren:'./login/login.module#LoginModule'},{path:'register',
                    loadChildren:'./register/register.module#RegisterModule'}]}],[{path:'schedule',
                canActivate:[i16.AuthGuard],loadChildren:'./schedule/schedule.module#ScheduleModule'},
                {path:'meals',canActivate:[i16.AuthGuard],loadChildren:'./meals/meals.module#MealsModule'},
                {path:'workouts',canActivate:[i16.AuthGuard],loadChildren:'./workouts/workouts.module#WorkoutsModule'}],
                [{path:'',pathMatch:'full',redirectTo:'schedule'}]];
          },([] as any[])),i0.ɵmpd(1024,i17.Router,i17.ɵe,[i0.ApplicationRef,i17.UrlSerializer,
              i17.ChildrenOutletContexts,i4.Location,i0.Injector,i0.NgModuleFactoryLoader,
              i0.Compiler,i17.ROUTES,i17.ROUTER_CONFIGURATION,[2,i17.UrlHandlingStrategy],
              [2,i17.RouteReuseStrategy]]),i0.ɵmpd(512,i17.RouterModule,i17.RouterModule,
              [[2,i17.ɵa],[2,i17.Router]]),i0.ɵmpd(512,i8.AngularFireModule,i8.AngularFireModule,
              ([] as any[])),i0.ɵmpd(512,i10.AngularFireAuthModule,i10.AngularFireAuthModule,
              ([] as any[])),i0.ɵmpd(512,i12.AngularFireDatabaseModule,i12.AngularFireDatabaseModule,
              ([] as any[])),i0.ɵmpd(512,i13.ɵba,i13.ɵba,([] as any[])),i0.ɵmpd(512,
              i13.ReactiveFormsModule,i13.ReactiveFormsModule,([] as any[])),i0.ɵmpd(512,
              i21.SharedModule,i21.SharedModule,([] as any[])),i0.ɵmpd(512,i22.AuthModule,
              i22.AuthModule,([] as any[])),i0.ɵmpd(512,i23.SharedModule,i23.SharedModule,
              ([] as any[])),i0.ɵmpd(512,i24.HealthModule,i24.HealthModule,([] as any[])),
          i0.ɵmpd(512,i1.AppModule,i1.AppModule,([] as any[])),i0.ɵmpd(256,i6.FirebaseAppConfigToken,
              {apiKey:'AIzaSyBIr0Mi8enCvavhiT5d-_x8J_NX8xkFAkM',authDomain:'fitness-app-ua-ffad7.firebaseapp.com',
                  databaseURL:'https://fitness-app-ua-ffad7.firebaseio.com',projectId:'fitness-app-ua-ffad7',
                  storageBucket:'fitness-app-ua-ffad7.appspot.com',messagingSenderId:'716655804729'},
              ([] as any[])),i0.ɵmpd(256,i8.FirebaseAppName,(undefined as any),([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2JlbmN1cnJpZS9Eb2N1bWVudHMvVWx0X0FuZy9hbmd1bGFyLXByby1zcmMvYW5ndWxhci1wcm8tYXBwLXNlZWQtbWFzdGVyL3NyYy9hcHAvYXBwLm1vZHVsZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9iZW5jdXJyaWUvRG9jdW1lbnRzL1VsdF9BbmcvYW5ndWxhci1wcm8tc3JjL2FuZ3VsYXItcHJvLWFwcC1zZWVkLW1hc3Rlci9zcmMvYXBwL2FwcC5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./ngfactory/src/app/app.module.ngfactory.ts